var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "home" } }, [
    _vm.hasCheck
      ? _c(
          "div",
          { staticClass: "content-spacer", attrs: { id: "body" } },
          [
            _c("CheckDetail", { attrs: { detail: _vm.checkDetail } }),
            _c(
              "div",
              {
                staticClass: "drop-shadow-sides",
                attrs: { id: "rest-of-body" },
              },
              [_c("PaymentOptions")],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }